module.exports = __webpack_public_path__ + "static/media/logo-abbott.cb8121b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-abbott.svg
// module id = 602
// module chunks = 0